<app-modal-header [title]="'Авторизация'" (closeModal)="close()"></app-modal-header>
<div class="modal-body">
  <p>Время сессии истекло, для продолжения работы в системе авторизуйтесь заново</p>
  <app-login-form></app-login-form>
</div>
